const getUrlWithFromCd = (url, pageCode, upMenuCd, menuCd) => {
    if (!url) {
        url = "";
    }

    const urlSplited = url.split("?");

    const urlPathname = urlSplited[0];
    const urlSearch = urlSplited.length > 1 ? urlSplited[1] : "";

    const urlParams = new URLSearchParams(urlSearch);
    urlParams.set("FROM_CD", pageCode);

    if (upMenuCd) {
        urlParams.set("UP_MENU_CD", upMenuCd);
    }

    if (menuCd) {
        urlParams.set("MENU_CD", menuCd);
    }

    return urlPathname + "?" + urlParams.toString();
};

export default getUrlWithFromCd;
